import { Box, ErrorIcon, Flex, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '../../hooks';

export const Alert = ({ label }: { label: string }) => {
  const { getKioskSpacing } = useKioskSpacing();

  return (
    <Box
      background="error-light"
      mb={getKioskSpacing(48, 24)}
      mx="auto"
      width="100%"
      borderRadius="sm"
      p={16}
    >
      <Flex alignItems="center" flexDirection="row">
        <ErrorIcon color="error-dark" mr={16} size="md" />
        <Typography color="error-dark" variant="body-bold">
          {label}
        </Typography>
      </Flex>
    </Box>
  );
};
